export const GETTING_START_PROJECT_PRODUCT = "GETTING_START_PROJECT_PRODUCT";
export const GET_START_PROJECT_PRODUCT_SUCCESS = "GET_START_PROJECT_PRODUCT_SUCCESS";
export const GET_START_PROJECT_PRODUCT_FAILED = "GET_START_PROJECT_PRODUCT_FAILED";
export const SET_PURCHASE_START_PROJECT_MODAL = "SET_PURCHASE_START_PROJECT_MODAL";
export const RESET_PURCHASE_START_PROJECT_MODAL = "RESET_PURCHASE_START_PROJECT_MODAL";
export const START_PURCHASE_START_PROJECT_SUBMIT = "START_PURCHASE_START_PROJECT_SUBMIT";
export const PURCHASE_START_PROJECT_FAILED = "PURCHASE_START_PROJECT_FAILED";
